/** Permission-gated navigation items for leadership / admin shells. */

export const LEADERSHIP_MENU = [
  {
    to: '/management',
    label: 'Management',
    permission: 'management.view',
    testid: 'nav-management',
    end: true,
  },
  {
    to: '/management/auth-audit',
    label: 'Auth audit',
    permission: 'audit.auth.view',
    testid: 'nav-auth-audit',
  },
  {
    to: '/management/users',
    label: 'Users',
    permission: 'admin.users',
    testid: 'nav-admin-users',
  },
  {
    to: '/management/roles',
    label: 'Roles',
    permission: 'admin.roles',
    testid: 'nav-admin-roles',
  },
  {
    to: '/management/permissions',
    label: 'Permissions',
    permission: 'admin.permissions',
    testid: 'nav-admin-permissions',
  },
  {
    to: '/management/specialisations',
    label: 'Specialisations',
    permission: 'admin.specialisations',
    testid: 'nav-admin-specs',
  },
  {
    to: '/management/roster',
    label: 'Roster',
    permission: 'roster.manage',
    testid: 'nav-roster',
  },
  {
    to: '/management/referral-inbox',
    label: 'Referral approvals',
    permission: 'management.view',
    testid: 'nav-referral-inbox',
  },
  {
    to: '/management/booking-settings',
    label: 'Configuration',
    permission: 'admin.booking_settings',
    testid: 'nav-booking-settings',
  },
  {
    to: '/management/visit-reports',
    label: 'Visit reports',
    permission: 'reports.view',
    testid: 'nav-reports',
  },
];

/** Reception / staff nurse — same campus chrome as FIC. */
export const RECEPTION_MENU = [
  { to: '/reception/home', label: 'Home', testid: 'rx-nav-home', end: true },
  { to: '/reception', label: 'Patient Onboarding', testid: 'rx-nav-desk' },
  { to: '/reception/roster', label: 'Roster', testid: 'rx-nav-roster' },
  { to: '/pharmacy', label: 'Pharmacy', testid: 'rx-nav-pharmacy' },
  { to: '/inventory', label: 'Inventory', testid: 'rx-nav-inventory' },
  { to: '/reception/reports', label: 'Visit reports', testid: 'rx-nav-reports' },
];

/** Doctor clinical workspace. */
export const DOCTOR_MENU = [
  { to: '/dashboard', label: 'Home', testid: 'doc-nav-dashboard', end: true },
  { to: '/doctor/referrals', label: 'Referrals', testid: 'doc-nav-referrals' },
  { to: '/inventory', label: 'Inventory', testid: 'doc-nav-inventory' },
];

/** Pharmacy / dispensing. */
export const PHARMACY_MENU = [
  { to: '/pharmacy', label: 'Dispense', testid: 'ph-nav-dispense', end: true },
  { to: '/inventory', label: 'Inventory', testid: 'ph-nav-inventory' },
];

/** Purchase operations. */
export const PURCHASE_MENU = [
  { to: '/purchase', label: 'Purchase', testid: 'pu-nav-home', end: true },
];

/** Patient portal. */
export const PATIENT_MENU = [
  { to: '/patient', label: 'Home', testid: 'pt-nav-home', end: true },
  { to: '/patient/appointments', label: 'Appointments', testid: 'pt-nav-appts' },
  { to: '/patient/referrals', label: 'Referrals', testid: 'pt-nav-referrals' },
  { to: '/patient/family', label: 'Family', testid: 'pt-nav-family' },
  { to: '/patient/care', label: 'Care history', testid: 'pt-nav-care' },
];

export const ADMIN_NAV_PERMISSIONS = {
  '/admin/overview': null,
  '/admin/users': 'admin.users',
  '/admin/roles': 'admin.roles',
  '/admin/permissions': 'admin.permissions',
  '/admin/specialisations': 'admin.specialisations',
  '/admin/roster': 'roster.manage',
  '/admin/auth-audit': 'audit.auth.view',
  '/admin/billing': 'admin.users',
  '/admin/branding': 'admin.users',
  '/admin/capabilities': 'admin.users',
  '/admin/domains': 'admin.users',
  '/admin/settings': 'admin.users',
};
